<template>
	<v-dialog :value="!!report" max-width="960" scrollable persistent @input="value => { if(!value) close() }">
		<v-card class="background-2 round-card import-report">
			<v-card-title class="pa-3">
				<p class="pl-2 pl-xl-3 mb-0">
					Risultato import fatture ricevute
					<small class="d-block grey--text" v-if="data">{{ data.created_at | datetime }}</small>
				</p>
				<v-spacer></v-spacer>
				<v-btn icon @click="close()"><v-icon>close</v-icon></v-btn>
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text class="pt-4 body-2">
				<v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
				<v-alert v-else-if="error" type="error" text dense>{{ error }}</v-alert>
				<template v-else-if="data">
					<div class="d-flex flex-wrap mb-4" style="gap: 8px">
						<v-chip small color="success" outlined>{{ data.imported }} importati</v-chip>
						<v-chip small color="warning" outlined>{{ data.skipped }} saltati</v-chip>
						<v-chip small color="error" outlined>{{ data.failed }} in errore</v-chip>
					</div>
					<v-simple-table dense>
						<thead>
							<tr>
								<th>Numero</th>
								<th>Fornitore</th>
								<th>Esito</th>
								<th>Dettaglio</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in sortedItems" :key="item.id + '-' + item.status" :class="'report-' + item.status">
								<td>{{ item.number || ('#' + item.id) }}</td>
								<td>{{ item.sender || '—' }}</td>
								<td>
									<v-chip x-small :color="statusColor(item.status)">{{ statusLabel(item.status) }}</v-chip>
								</td>
								<td>
									<template v-if="item.status === 'imported'">
										<a v-if="item.document_id" :href="'#/invoices/' + item.document_type + 's/' + item.document_id">
											Apri {{ item.document_number ? 'documento ' + item.document_number : 'documento' }}
										</a>
									</template>
									<template v-else>
										<v-chip x-small outlined color="error" class="mr-1 my-1" v-for="block in item.blocks" :key="block">{{ block }}</v-chip>
										<a v-if="item.edocument_exists" :href="'#/invoices/edocuments/' + item.id + '/import'" target="_blank" class="d-inline-block">Apri nel wizard</a>
										<small v-else class="d-block grey--text">Il documento ricevuto non esiste più.</small>
									</template>
								</td>
							</tr>
						</tbody>
					</v-simple-table>
				</template>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
	/**
	 * Resoconto di un lotto di import massivo, aperto dalla notifica di fine
	 * import (query ?import_report=<nome> sull'elenco dei documenti ricevuti).
	 */
	export default {
		name: 'import-edocuments-report-dialog',
		props: {
			report: String,
		},
		data() {
			return {
				data: null,
				loading: false,
				error: '',
			}
		},
		computed: {
			// prima i non importati, che sono quelli da sistemare
			sortedItems() {
				const items = (this.data && this.data.items) || []
				return items.filter(item => item.status !== 'imported').concat(items.filter(item => item.status === 'imported'))
			},
		},
		watch: {
			report: {
				immediate: true,
				handler(value) {
					this.data = null
					this.error = ''
					if(value) {
						this.load(value)
					}
				},
			},
		},
		methods: {
			load(report) {
				this.loading = true
				this.axios.get('import-edocuments-reports/' + encodeURIComponent(report)).then(response => {
					this.loading = false
					this.data = response.data
				}, () => {
					this.loading = false
					this.error = 'Resoconto non disponibile.'
				})
			},
			statusLabel(status) {
				return { imported: 'importato', skipped: 'saltato', failed: 'errore' }[status] || status
			},
			statusColor(status) {
				return { imported: 'success', skipped: 'warning', failed: 'error' }[status] || ''
			},
			close() {
				this.$emit('close')
			},
		},
	}
</script>
